/** Row gap between filter slots — Figma: spacing/2x = 8px */
export const FILTERS_ROW_GAP = 'gap-2';

/** Máximo de slots visibles en la barra; el resto va al slideout «All filters». */
export const FILTERS_BAR_MAX_SLOTS = 4;

/** Slot / field height — Figma: 40px */
export const FILTERS_SLOT_HEIGHT = 'h-10';

/** Chip label truncation — Figma spec: 14 characters */
export const FILTERS_CHIP_TRUNCATE = 'truncate max-w-[14ch]';

/**
 * Outlined text field (Figma node 7996:5502).
 * Chips and placeholder live inside; chevron on the right.
 */
export const FILTERS_FIELD_BASE = [
  'inline-flex h-10 min-w-[9rem] max-w-full shrink-0 cursor-pointer items-center gap-1',
  'rounded-lg border border-edge bg-surface px-4 py-1',
  'text-sm font-medium leading-5 text-content',
  'outline-none transition-colors',
  'hover:border-accent/50',
  'focus-visible:border-accent/50 focus-visible:ring-1 focus-visible:ring-accent/50',
  'disabled:cursor-not-allowed disabled:opacity-50',
].join(' ');

/**
 * Tag Component inside the field (Figma: h-24px, radius-m, primary/subtle).
 * Applied on top of Badge informative variant.
 */
export const FILTERS_CHIP_BASE = [
  'h-6 gap-1 px-2 py-1',
  'text-sm font-medium leading-5',
  'text-[#001740] dark:text-blue-100',
].join(' ');

export const FILTERS_DROPDOWN_BASE = [
  'absolute top-full z-[100] mt-1',
  'min-w-[max(100%,12rem)] w-max max-w-[min(28rem,calc(100vw-2rem))]',
  'max-h-[min(24rem,55vh)] overflow-y-auto',
  'rounded-lg border border-edge bg-surface py-1 shadow-lg',
  'scrollbar-aimsos-auto-sm',
].join(' ');

export const FILTERS_DROPDOWN_OPTION = [
  'flex cursor-pointer items-center gap-2.5 px-3 py-2 text-sm transition-colors',
  'text-content hover:bg-surface-hover',
].join(' ');

export const FILTERS_DROPDOWN_OPTION_SELECTED = 'bg-accent/10 text-content';

/** Global "Clear Filters" — Figma 7996:5525: ghost text button after all slots */
export const FILTERS_CLEAR_ALL_BUTTON = [
  'inline-flex h-10 shrink-0 items-center justify-center',
  'rounded-lg px-4 py-2',
  'text-sm font-medium leading-5 text-content',
  'transition-colors hover:text-content-secondary',
  'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-accent/50',
].join(' ');

/** Search en toolbar — 88px celulares (`< sm` / 640px); 225px en el resto. Ver `filtersResponsive.js`. */
export const FILTERS_SEARCH_CLASS = [
  'w-[88px] min-w-[88px] max-w-[88px] shrink-0',
  'sm:w-[225px] sm:min-w-[225px] sm:max-w-[225px]',
  FILTERS_SLOT_HEIGHT,
  '[&_input]:h-full [&_input]:min-h-0 [&_input]:py-0 [&_input]:leading-none',
].join(' ');

/**
 * Toolbar shell — Figma 7996:5491.
 * Compact (`< xl`): `justify-start`. Desktop (`xl+`): `justify-between`.
 */
export const FILTERS_ROOT_ROW = [
  'flex min-w-0 flex-nowrap items-center overflow-visible',
  FILTERS_ROW_GAP,
  'justify-start xl:justify-between',
].join(' ');

export const FILTERS_SLOTS_ROW = [
  'flex min-w-0 flex-nowrap items-center overflow-visible',
  FILTERS_ROW_GAP,
  'xl:min-w-0 xl:flex-1',
].join(' ');

export const FILTERS_ACTIONS_ROW = 'flex shrink-0 flex-wrap items-center gap-3';

/**
 * Right group — Figma 7996:5370: gap 16px.
 * En compact (`< xl`): solo «All filters» junto al search; sort / view / actions ocultos.
 */
export const FILTERS_RIGHT_GROUP =
  'flex shrink-0 flex-nowrap items-center gap-4 overflow-visible';

/** Sort, view toggle y `actions` — visibles solo en desktop (`xl+`). */
export const FILTERS_RIGHT_DESKTOP_ONLY = 'hidden xl:contents';

/** Sort block — Figma 7996:5557: gap 24px between direction icon and Name+chevron. */
export const FILTERS_SORT_GROUP = 'relative flex shrink-0 items-center gap-6';

/** Ghost icon control — Figma Buttons-NEW ~28px, radius-s 4px, 16px icon. */
export const FILTERS_SORT_ICON_BUTTON = [
  'inline-flex size-7 shrink-0 items-center justify-center',
  'rounded p-1 text-content-secondary',
  'outline-none transition-colors',
  'hover:bg-surface-hover hover:text-content',
  'focus-visible:ring-1 focus-visible:ring-accent/50',
  'disabled:cursor-not-allowed disabled:opacity-50',
].join(' ');

/** Name + chevron row — Figma 7996:5560: gap 8px, no bordered field. */
export const FILTERS_SORT_FIELD_ROW = 'inline-flex items-center';

/** Sort MenuPanel — anclado a la derecha del trigger (toolbar alineado a la derecha). */
export const FILTERS_SORT_MENU_ANCHOR = [
  'absolute right-0 top-full z-[100] mt-1',
  'min-w-[16.25rem] w-max max-w-[min(28rem,calc(100vw-2rem))]',
].join(' ');

/** Sort field label — Figma Body/M 14px medium #5c5c5c */
export const FILTERS_SORT_FIELD_LABEL =
  'text-sm font-medium leading-5 text-content-secondary';

/** View toggle buttons in toolbar — 40×40px (same as filter fields). */
export const FILTERS_VIEW_TOGGLE_BUTTON = 'h-10 max-h-10 w-10 shrink-0';

/** All filters — Figma 11322:3358: pill, 40px, border #5c5c5c, SlidersHorizontal ~20px a la derecha. */
export const FILTERS_ALL_FILTERS_BUTTON = 'shrink-0 gap-2 px-4 font-medium';
